import styled from '@emotion/styled'
import { ChannelBox, ChannelLogo } from 'planby'
import { Placement } from '../../helpers'

export const StyledChannelBox = styled(ChannelBox)(() => ({
  padding: '2px 0',
  paddingTop: '2px',
  paddingBottom: '3px',
}))

export const StyledChannelLink = styled('a')(() => ({
  width: '100%',
  height: '100%',
}))

export interface StyledInnerChannelBoxProps {
  color: string
  placement: Placement
}
export const StyledInnerChannelBox = styled('div')<StyledInnerChannelBoxProps>(({ color, placement }) => ({
  backgroundColor: color,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  '&:hover': {
    background: color + (placement === '7plus' ? 'CC' : 'B3'),
  },
  transition: 'all 0.3s ease-in-out',
}))

export interface StyledChannelLogoProps {}
export const StyledChannelLogo = styled(ChannelLogo)<StyledChannelLogoProps>(() => ({
  maxHeight: '62px',
  height: '82px',
  maxWidth: '91px',
  width: 'auto',
}))
